import * as Types from './types'

export const onSaveAndActionChange = selectedOption => ({
  type: Types.SAVE_AND_ACTION_CHANGE,
  payload: selectedOption
})

export const setLogInAsCustomerOptions = (options, userId) => ({
  type: Types.SET_LOGIN_AS_CUSTOMER_OPTIONS,
  payload: { options, userId }
})
